import { gql } from "@apollo/client";

export const findRewardsByIds = gql`
  query FindRewardsByIds($ids: [ID!]!) {
    findRewardsByIds(ids: $ids) {
      id
      name
      rewardId
      rewardName
      description
      shortDescription
      partnerId
      programId
      campaignId
      partnerCodeType
      quantity
      linkType
      inventoryNumber
      createdInPlatform
      exchangeable
      autoClaim
      unlimitedInventory
      rewardItemGroup
      percentReward
      rewardCategoryIds
      imageUrl
      wheelImageUrl
      rewardItemGroupId
      isActive
      isAttached
      partnerName
      coverImageUrl
      buttonText
      webUrl
      appUrl
      sms
      smsNumber
      androidAppId
      iosAppId
      rewardTypeId
      rewardTypeName
      category
      parentRewardGroupRewardId
      rewardUnitId
      rewardTypeData
      type
      catalogId
    }
  }
`;
